export const PRODUCT = "/product/:id";
export const PRODUCT_RAW = "/product";